<template>
  <div :class="offset">
    <div class="sidebar-layout__toolbar" v-if="!isMobile">
      <v-btn
        v-if="userType !== 'employee'"
        medium
        :disabled="!hasPermission('ingredient_type', 'add')"
        @click="modal.showCreateType = true"
      >
        <v-icon position-left font-size="1" icon="plus" />
        <span>{{ $t('base.add_ingredient_type') }}</span>
      </v-btn>
    </div>
    <template v-else>
      <v-btn
        v-if="userType !== 'employee'"
        fab
        :disabled="!hasPermission('ingredient_type', 'add')"
        @click="modal.showCreateType = true"
      >
        <v-icon font-size="1.2" icon="plus" />
      </v-btn>
    </template>

    <v-dialog max-width="400" v-model="modal.showCreateType">
      <create-type-modal
        @close="closeCreateModal"
        @update="onUpdate"
      />
    </v-dialog>

    <v-dialog max-width="400" v-model="modal.showSettingsType">
      <settings-type-modal
        v-if="modal.showSettingsType"
        @close="closeSettingsModal"
        @update="onUpdateAndClose"
        @remove="onUpdateAndClose"
      />
    </v-dialog>

    <template v-if="!isMobile">
      <types-table ref="childComponentRef" />
    </template>

    <template v-if="isMobile">
      <types-table-mobile ref="childComponentMobileRef" />
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import api from '@/api'
import adaptationMixin from '@/mixins/adaptation.mixin.js'

import CreateTypeModal from './modals/CreateTypeModal'
import SettingsTypeModal from './modals/SettingsTypeModal'

const TypesTable = () => import('./TypesTable')
const TypesTableMobile = () => import('./TypesTableMobile')

export default {
  name: 'IngredientTypes',

  mixins: [adaptationMixin],

  components: {
    TypesTable,
    TypesTableMobile,
    CreateTypeModal,
    SettingsTypeModal
  },

  async created () {
    try {
      const { data } = await api.account.get()
      this.userType = data.user_type
    } catch (error) {
      console.error('Failed to fetch user type:', error)
      this.userType = null
    }
  },

  data: () => ({
    userType: null,
    modal: {
      showCreateType: false,
      showSettingsType: false
    }
  }),

  computed: {
    ...mapGetters('ingredienttypes', [
      'currentIngredientType'
    ]),

    offset () {
      return null
    }
  },

  watch: {
    currentIngredientType (newVal) {
      if (newVal !== null && !this.modal.showSettingsType) {
        this.modal.showSettingsType = true
      }
    }
  },

  methods: {
    ...mapActions('ingredienttypes', [
      'closeIngredientType'
    ]),

    closeCreateModal () {
      this.modal.showCreateType = false
    },

    closeSettingsModal () {
      this.modal.showSettingsType = false
      this.closeIngredientType()
    },

    onUpdate () {
      if (this.$refs.childComponentRef) {
        this.$refs.childComponentRef.updateData()
      }
      if (this.$refs.childComponentMobileRef) {
        this.$refs.childComponentMobileRef.updateData()
      }
    },

    async onUpdateAndClose () {
      await this.onUpdate()
      await this.$nextTick()
      this.closeSettingsModal()
    }
  }
}
</script>